import styled from 'styled-components';

import { media } from '@theme/media';

import { containerStyles, paragraphTextStyles } from '../blocks.styles';

export const Container = styled.div`
  ${containerStyles};
  ${paragraphTextStyles};
  text-align: center;
  white-space: pre-wrap;
  padding-top: 0.7em;

  ${media.tablet} {
    padding-top: 1.4em;
  }
`;
